import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { HttpUtilsService } from '../_base/crud';
import { currentAuthToken, currentUser } from '../auth';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  private authToken: any;
  private companyId: any;
  userInfo: any;

  constructor(
    private httpClient: HttpClient,

    private store: Store<AppState>,
    private httpUtils: HttpUtilsService,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => {
      if (res) {
        this.companyId = res.companyID;
        this.userInfo = res;
      }
    });
  }

  searchTags(
    category,
    autocompleteEntity:
      | 'DOCTOR'
      | 'PATIENT'
      | 'FACILITY'
      | 'CONTACT'
      | 'COMMUNICATION'
      | 'DOCUMENT',
    term: string,
  ): Observable<any> {
    let baseUrl = '';
    switch (category) {
      case 'Entity':
        baseUrl = environment.CORE_BASE;
        break;
      case 'Communication':
        baseUrl = environment.TIMELINE_BASE;
        break;
    }
    const url = `${baseUrl}/companies/${this.companyId}/tags/autocomplete?term=${term}&type=${autocompleteEntity}`;
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.httpClient.get<any>(url, { headers: httpHeaders });
  }

  tagsAutocomplete(term) {
    const url = `${environment.TIMELINE_BASE}/companies/${this.companyId}/tags/autocomplete`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const params = new HttpParams().append('term', term);
    return this.httpClient.get<any>(url, { headers, params });
  }
}
